var publicData = require('./services/publicData');
var authorization = require('./services/authorization');
var router = require('./services/router');

var preloader = require('./components/preloader');
var messages = require('./components/messages');

var Login = require('./LoginPage');
var RequestAccount = require('./RequestAccountPage');
var ExistingOrders = require('./ExistingOrdersPage');
var CreateNewOrder = require('./CreateNewOrderPage');
var YourAddresses = require('./YourAddressesPage');
var ResetPassword = require('./ResetPasswordPage');

var AppViewModel = function () {
    var self = this;

    this.routes = router.routes;
    this.isAuthorized = authorization.isAuthorized;
    this.logout = function () {
        preloader.show('logout');
        authorization.logout(function (status) {
            if (!status) return;

            self.clean();
            router.goTo('login');
            preloader.hide('logout');
        });
    };

    this.active_page = ko.observable(null);
    this.messages = messages;

    this.login = new Login();
    this.request_account = new RequestAccount();
    this.create_new_order = new CreateNewOrder();
    this.update_existing_order = new CreateNewOrder();
    this.existing_orders = new ExistingOrders();
    this.your_addresses = new YourAddresses();
    this.reset_password = new ResetPassword();

    this.captcha = ko.observable('');

    this.onShow = function (page) {
        self.setActivePage(page);

        if (page.page.ctx.onShow) page.page.ctx.onShow();
    };

    this.onHide = function (page) {
        if (page.page.ctx.onHide) page.page.ctx.onHide();
    };

    this.setActivePage = function (page) {
        if (self.active_page() == self.routes['your-addresses'] && self.your_addresses.editable()) {
            alert('You don\'t save changes in addresses');
        }

        self.active_page(page.page.currentId);

        if (typeof page.page.ctx.load === 'function') {
            page.page.ctx.load();
        }
    };

    this.clean = function () {
        self.login.clean();
        self.create_new_order.clean();
        self.existing_orders.clean();
        self.your_addresses.clean();
    };

    this.init = function (callback) {
        preloader.show('view-model');

        $.ajax({
            url: 'rest.php/init_data',
            method: 'GET',
            dataType: 'json',
            context: this
        }).done(function (resp) {
            if (resp.password_complexity_update_required) {
                location.href = "/service/change_password_required.php?src=bulk_po";
            } else {
                authorization.setIsAuthorized(true);
                var initData = resp.data;
                self.existing_orders.init(initData.quotes, initData.orders);
                self.your_addresses.init(initData.addresses);
                if(self.your_addresses.missing_address()) {
                    router.goTo('your-addresses');
                    messages.addItem('You must enter your Bill to and Ship to address before proceeding');
                }
            }
        }).fail(function (jqXHR, textStatus, error) {
            var error = jqXHR.responseJSON.error;

            if (error.code === 401) {
                router.goTo('login');
                authorization.setIsAuthorized(false);
            } else {
                messages.addItem(error.message);
            }


            if (callback) callback(false);
        }).always(function () {
            preloader.hide('view-model');
        });
    };
};

module.exports = new AppViewModel();



//////////////////
// WEBPACK FOOTER
// ../textbookx/service/bulk_po/scripts/viewModel.js
// module id = 6
// module chunks = 0